// frameworkService - Framework API client
// Implements US-2.1: Framework selection during workspace creation

import axios from 'axios';
import { ListFrameworksResponse } from '../types';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

/**
 * LIST all available frameworks
 * - Public endpoint, no authentication required
 * - Returns all frameworks with criteria definitions
 * - Used in workspace creation form
 *
 * @returns List of available frameworks
 * @throws Error if request fails
 */
export async function listFrameworks(): Promise<ListFrameworksResponse> {
  try {
    const response = await axios.get<ListFrameworksResponse>(`${API_URL}/api/frameworks`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.error || 'Failed to fetch frameworks');
    }
    throw new Error('An unexpected error occurred');
  }
}
